import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=61083b54&scoped=true&"
import script from "./HomeHero.vue?vue&type=script&lang=js&"
export * from "./HomeHero.vue?vue&type=script&lang=js&"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=61083b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61083b54",
  null
  
)

export default component.exports